@if (resolvedLoading()) {
    <qpx-loader
        size="sm"
        containerClass="shrink-0"
        [ariaLabel]="loaderAriaLabel()"
    />
} @else if (resolvedIcon(); as iconName) {
    <ng-icon
        qpx
        size="sm"
        [context]="resolvedIconContext()"
        [tone]="resolvedIconTone()"
        [name]="iconName"
    />
}

@if (organisationState() === 'recognised') {
    <span class="organisation min-w-0 flex-1">
        <span qpxCell="secondary" tone="muted" variant="sm" class="block">
            {{ organisationLabel() }}
        </span>
        <span
            qpxCell
            variant="md"
            qpxOverflow
            #overflow="qpxOverflow"
            class="block min-w-0 truncate"
            [qpxTooltip]="organisationName() ?? ''"
            [matTooltipDisabled]="!overflow.isOverflowing()"
            [attr.tabindex]="overflow.isOverflowing() ? 0 : null"
        >
            {{ organisationName() }}
        </span>
    </span>
} @else if (organisationState()) {
    <span>{{ message() }}</span>
}

<ng-content />
